<template>
  <div id="app" v-if="isLoaded">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLoaded:false,
        showAbout:false
      }
    },
    beforeCreate () {
      this.$store.dispatch('loadContent').then(() => {
        this.isLoaded = true
      })
    }
  }
</script>

<style lang="scss">
@import 'node_modules/reset-css/sass/_reset';
@font-face {
  font-family: 'Boogie';
  src:url('/public/assets/BoogieSchoolSans-Middle6th.woff'), url('/public/assets/BoogieSchoolSans-Middle6th.woff2');
}

* {
  box-sizing: border-box;
}
a, a:hover, a:visited, a:active {
  color:black;
  text-decoration: none;
  outline: none;
  &:hover {
    color:rgba(0,0,0,0.5);
  }
}

p {
  margin-bottom:1em;
  &:last-of-type {
    margin-bottom:0;
  }
}

body, html {
  line-height: 1.2;
}

#app {
  font-family: "Boogie", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:4rem;
  ul, li {
    list-style: none;
    margin:0;
    padding:0;
  }
}
</style>
